module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RecordListView.js"));
	}, "MaterialRecordListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MaterialRecordListView!./src/pages/Promote/BusinessHall/AlterMaterial/RecordList/RecordListView.js
// module id = 2078
// module chunks = 367